import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlanContainerLocationCount } from "../../domain/models/plan-container-location-count";
import { MasterPlansRepository, MasterlocationRepository } from "../../repositories";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GetLocationCountUseCase implements UseCase<string, PlanContainerLocationCount>{
  
  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }
  execute(param: string): Observable<PlanContainerLocationCount> {
   return this.masterPlanRepository.getLocationCountByLocationType(param);
  }

}